

























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter, Mutation, Action } from "vuex-class";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import BorderBox from "./BorderBox/BorderBox.vue";
import {
  GETTER_INS_USER_INFO_LIST,
  GETTER_CURRENT_INS_USER_INFO,
  SHOW_SEARCH_OR_LOGIN
} from "@/store/constants/ins_user_info_types";
import {
  CHANGE_CURRENT_INS_USER_ID,
  GETTER_CURRENT_USER_ID
} from "@/store/constants/index_types";
import Loading from "@/components/Loading/Loading.vue";
import ImgFetched from "@/components/ImgFetched/ImgFetched.vue";

@Component({
  components: { swiper, swiperSlide, BorderBox, Loading, ImgFetched }
})
export default class UserInfo extends Vue {
  @Action(SHOW_SEARCH_OR_LOGIN)
  private showLoginOrSearch: any;
  @Action(CHANGE_CURRENT_INS_USER_ID)
  private changeCurrentInsUserId: any;
  @Getter(GETTER_INS_USER_INFO_LIST)
  private insUserList: any;
  @Getter(GETTER_CURRENT_INS_USER_INFO)
  private currentUserInfo: any;
  @Getter(GETTER_CURRENT_USER_ID)
  private currentUserId: any;
  @Prop()
  private userInfo!: any;
  @Prop()
  private type!: any;

  private defaultUserName: string = "Add Account";
  private defaultFolllowCount: number = 0;
  private cacheUserId: any = null;

  private activeIndex = 0;
  private slideIndex = 0;

  private swiperRef() {
    const refs: any = this.$refs;
    return refs.userSwiper && refs.userSwiper.swiper;
  }

  private checkIsPointEmptyUser() {
    if (
      this.insUserList.length === 0 ||
      this.activeIndex === this.insUserList.length
    ) {
      return true;
    }
    return false;
  }

  get followCountLoadingShow() {
    return false;
  }

  get getUsername() {
    console.log("this.activeIndex：", this.activeIndex, this.insUserList);
    if (this.checkIsPointEmptyUser()) {
      return this.defaultUserName;
    } else {
      return (
        (this.currentUserInfo &&
          this.currentUserInfo.ins_user_info &&
          this.currentUserInfo.ins_user_info.user_name) ||
        ""
      );
    }
  }

  get getFollowCount() {
    if (this.checkIsPointEmptyUser()) {
      return 0;
    } else {
      return (
        (this.currentUserInfo &&
          this.currentUserInfo.ins_user_info &&
          this.currentUserInfo.ins_user_info.follower_count) ||
        0
      );
    }
  }

  get swiperOption() {
    return {
      slidesPerView: "auto",
      centeredSlides: true,
      observer: true,
      slideToClickedSlide: true,
      initialSlide: this.slideIndex,
      lazy: {
        loadPrevNextAmount: 3
      },
      on: {
        slideChange: () => {
          if (this.swiperRef()) {
            this.activeIndex = this.swiperRef().activeIndex;
            // 手动改变current_user_id:
            setTimeout(() => {
              // 延迟触发，避免卡顿
              this.slideToChangeCurrentUserId(this.activeIndex);
            });
          }
        }
      }
    };
  }

  @Watch("currentUserId", { immediate: true })
  private watchCurrentId(val: any, oldval: any) {
    console.log("watchCurrentId:", {
      val,
      oldval
    });
    // 从最后的slide返回不会触发current_id的变化
    if (val !== oldval) {
      if (val) {
        this.slideToCurrentUserId();
      } else {
        // 删除了全部的账号
        this.slideIndex = 0;
      }
    }
  }

  private slideToChangeCurrentUserId(activeIndex: any) {
    // 如果发现active_index中的user_id和current_user_id相同 不改变
    if (
      this.insUserList[activeIndex] &&
      this.insUserList[activeIndex].user_id &&
      this.insUserList[activeIndex].user_id !== this.currentUserId
    ) {
      this.changeCurrentInsUserId(this.insUserList[activeIndex].user_id);
    }
  }

  private slideToCurrentUserId() {
    const slideIndex = this.insUserList.findIndex(
      (item: any) => item.user_id === this.currentUserId
    );
    if (this.swiperRef() && slideIndex > -1) {
      this.swiperRef().slideTo(slideIndex);
    }
  }

  private init() {
    this.slideToCurrentUserId();
  }

  private clickAddUser() {
    this.showLoginOrSearch();
  }

  private mounted() {
    this.$nextTick(() => {
      this.init();
    });
  }
}
